import axios from 'axios';
export interface getListPublish {
  customerId: number;
  salesMethod?: string;
}
export interface CheckinPublishCustomer {
  customerId: number;
  campaignId: number;
  image: string;
  imageBase64?: string;
}

export class PublishAPI {
  getListPublish = async (params: getListPublish) => {
    let path = `/api/Campaign`;
    const response = await axios.get(
      path +
        `?customerId=${params.customerId}` +
        (params.salesMethod ? `&salesMethod=${params.salesMethod}` : "")
    );
    return response.data;
  };

  checkInPublishCustomer = async (params: CheckinPublishCustomer) => {
    let path = `/api/Campaign/Checkin`;
    const response = await axios.post(path, params);
    return response.data;
  };
}
